

























































































































import Vue from "vue";
import { Form } from "element-ui";
import { axios } from "@/plugins";
import { CreateIngressForm } from "./transform";
import { uuid } from "../../utils/uuid";
import { mapState, mapGetters } from "vuex";

interface PathItem {
  url: string;
  sdf: string;
  port: number;
}

export default Vue.extend({
  name: "Edit",
  props: {
    projectId: { type: String }
  },
  data() {
    return {
      dialog: false,
      isEdit: false,
      ruleForm: JSON.parse(JSON.stringify(CreateIngressForm)),
      loading: false,
      keyOptions: [],
      serviceOptions: []
    };
  },
  computed: {
    rules: function() {
      if (this.isEdit) {
        return {
          "spec.rules[0].host": [
            {
              required: true,
              type: "string"
            }
          ]
        };
      } else {
        return {
          "metadata.name": [
            {
              required: true,
              type: "string",
              pattern: /^[a-z0-9]([-a-z0-9]*[a-z0-9])?(\.[a-z0-9]([-a-z0-9]*[a-z0-9])?)*$/
            }
          ],
          "spec.rules[0].host": [
            {
              required: true,
              type: "string"
            }
          ]

          // path: [{ required: true, trigger: "change" }]
        };
      }
    },
    ...mapState("LoginInfo", ["project"]),
    ...mapGetters("LoginInfo", ["tenant"])
  },
  mounted() {
    this.getKey();
    this.getService();
  },

  methods: {
    // 获取密钥
    getKey() {
      axios
        .get(`/secret/list?projectId=${this.projectId}&type=TLS`)
        .then(res => {
          this.keyOptions = res.data.data;
        });
    },
    getService() {
      axios
        .get(`/service/${this.projectId}?listId=${uuid()}&size=1000`)
        .then(res => {
          this.serviceOptions = res.data.data.list;
        });
    },
    show(data?: any) {
      if (data) {
        // 编辑模式
        this.ruleForm = this.initData(data);
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.dialog = true;
    },
    quit() {
      this.ruleForm = JSON.parse(JSON.stringify(CreateIngressForm));
      this.$nextTick(() => {
        (this.$refs.ruleForm as Form).clearValidate();
        this.dialog = false;
      });
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(vakid => {
        if (vakid) {
          if (this.isEdit) {
            this.edit();
          } else {
            this.create();
          }
        }
      });
    },
    edit() {
      axios
        .put(
          `/ingress/${this.projectId}/${this.ruleForm.metadata.name}`,
          this.buildData(this.ruleForm)
        )
        .then(() => {
          this.$message.success("路由信息修改成功");
          this.quit();
          this.$emit("afterEdit");
        });
    },
    create() {
      axios
        .post(`/ingress/${this.projectId}`, this.buildData(this.ruleForm))
        .then(() => {
          this.$message.success("路由创建成功");
          this.quit();
          this.$emit("afterEdit");
        });
    },
    buildData(data: any) {
      const buildData = JSON.parse(JSON.stringify(data));
      if (buildData.protocolType == "http") {
        delete buildData.spec.tls;
      } else {
        buildData.spec.tls[0].hosts = [
          buildData.spec.rules && buildData.spec.rules[0].host
        ];
      }
      if (!buildData.kind) {
        buildData.kind = "Ingress";
      }
      if (!buildData.apiVersion) {
        buildData.apiVersion = "extensions/v1beta1";
      }
      buildData.metadata.labels.app = buildData.metadata.name;
      buildData.metadata.namespace = `${this.tenant.code}-${this.project.projectName}`;
      delete buildData.protocolType;
      return buildData;
    },
    initData(data: any) {
      const buildData = JSON.parse(JSON.stringify(data));
      if (!buildData.kind) {
        buildData.kind = "Ingress";
      }
      if (!buildData.apiVersion) {
        buildData.apiVersion = "extensions/v1beta1";
      }
      if (buildData.spec.tls) {
        buildData.protocolType = "https";
      } else {
        buildData.protocolType = "http";
      }
      return buildData;
    },
    addPath() {
      if (this.ruleForm.spec.rules) {
        this.ruleForm.spec.rules[0].http.paths.push({
          path: "/",
          backend: {
            serviceName: "",
            servicePort: ""
          }
        });
      }
    },
    delPath(index: number) {
      if (
        this.ruleForm.spec.rules &&
        this.ruleForm.spec.rules[0].http.paths.length === 1
      )
        return;
      this.ruleForm.spec.rules &&
        this.ruleForm.spec.rules[0].http.paths.splice(index, 1);
    }
  }
});
